class NoolabPersonalization {
  constructor(root) {
    this.root = root;
    this.form = root.closest('form[action*="/cart/add"]');
    if (!this.form || root.dataset.noolabPersonalizationReady === 'true') return;

    root.dataset.noolabPersonalizationReady = 'true';
    this.form.addEventListener('submit', (event) => this.validate(event), { capture: true });

    this.inputs.forEach((input) => {
      input.addEventListener('invalid', () => this.validateInput(input));
      input.addEventListener('input', () => {
        if (input.getAttribute('aria-invalid') === 'true') this.validateInput(input);
      });
    });
  }

  get inputs() {
    return this.root.querySelectorAll('[data-noolab-personalization-input]');
  }

  validateInput(input) {
    const value = input.value.trim();
    const missing = input.required && value.length === 0;
    const errorId = input.getAttribute('aria-errormessage');
    const error = errorId ? document.getElementById(errorId) : input.parentElement.querySelector('.noolab-personalization__error');
    const label = input.labels?.[0]?.innerText.replace('*', '').trim() || 'This field';
    const messageTemplate = this.root.dataset.requiredMessage || '[field] is required.';

    input.setAttribute('aria-invalid', missing ? 'true' : 'false');
    if (error) {
      error.textContent = missing ? messageTemplate.replace('[field]', label) : '';
      error.hidden = !missing;
    }

    return !missing;
  }

  validate(event) {
    let firstInvalid = null;

    this.inputs.forEach((input) => {
      if (!this.validateInput(input) && !firstInvalid) firstInvalid = input;
    });

    if (firstInvalid) {
      event.preventDefault();
      event.stopImmediatePropagation();
      firstInvalid.focus();
    }
  }
}

function initialiseNoolabPersonalisation(scope = document) {
  scope.querySelectorAll('[data-noolab-personalization]').forEach((root) => {
    new NoolabPersonalization(root);
  });
}

initialiseNoolabPersonalisation();
document.addEventListener('shopify:section:load', (event) => initialiseNoolabPersonalisation(event.target));
